import axios from 'axios'

/**
 * initial state
 */
const state = () => ({
  // todo
  currentBuildingInfo: localStorage.getItem('currentBuildingInfo') || '',
})

/**
 * getters
 */
const getters = {
  // todo
  getCurrentBuildingInfo(state) {
    if (state.currentBuildingInfo) {
      return JSON.parse(state.currentBuildingInfo)
    } else return ''
  },
}

/**
 * mutations
 */
const mutations = {
  // todo

  /**
   * Set currentBuildingInfo
   * @param {*} state
   * @param {*} data
   */
  setCurrentBuildingInfo(state, data) {
    state.currentBuildingInfo = data
  },

  /**
   * Clear CurrentBuilding information
   */
  clearCurrentBuildingInfo(state) {
    state.currentBuildingInfo = ''
  },
}

/**
 * actions
 */
const actions = {
  /**
   * Clear CurrentBuilding information
   */
  clearCurrentBuildingInfo(context) {
    console.log('clear currentBuildingInfo')
    context.commit('clearCurrentBuildingInfo')
    localStorage.removeItem('currentBuildingInfo')
  },

  /**
   * Creat address
   */
  createAddress(context, address) {
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_ADDRESS_CREATE, {
          address_type_id: Number(address.address_type_id),
          address_type_ref: address.address_type_ref,
          group_number: address.group_number,
          title_deed_number: address.title_deed_number,
          building: address.building,
          room_number: address.room_number,
          floor: address.floor,
          village_no: address.village_no,
          alley: address.alley,
          road: address.road,
          province: address.province,
          district: address.district,
          sub_district: address.sub_district,
          province_name: address.province_name,
          district_name: address.district_name,
          subdistrict_name: address.subdistrict_name,
          postcode: address.postcode,
          country: address.country,
        })
        .then((response) => {
          console.log('API create address ::', response.data)
          if (response.data.isSuccess) {
            localStorage.setItem('currentBuildingInfo', JSON.stringify(response.data.data))
            context.commit('setCurrentBuildingInfo', JSON.stringify(response.data.data))
            resolve(response.data.data)
          } else {
            console.error(response.data)
            reject(response.data.message)
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * View
   */

  /**
   * Updated
   */
  updateAddress(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .put(process.env.VUE_APP_ADDRESS_UPDATE + '/' + credentials.addressId, {
          address_type_id: Number(credentials.address_type_id),
          address_type_ref: credentials.address_type_ref,
          group_number: credentials.group_number,
          title_deed_number: credentials.title_deed_number || null,
          building: credentials.building || null,
          room_number: credentials.room_number || null,
          floor: credentials.floor || null,
          village_no: credentials.village_no || null,
          alley: credentials.alley || null,
          road: credentials.road || null,
          province: Number(credentials.province),
          district: Number(credentials.district),
          sub_district: Number(credentials.sub_district),
          province_name: credentials.province_name,
          district_name: credentials.district_name,
          subdistrict_name: credentials.subdistrict_name,
          postcode: credentials.postcode,
          country: credentials.country,
        })
        .then((response) => {
          console.log('API update address ::', response.data)
          if (response.data.isSuccess) {
            localStorage.setItem('currentBuildingInfo', JSON.stringify(response.data.data))
            context.commit('setCurrentBuildingInfo', JSON.stringify(response.data.data))
            resolve(response.data.data)
          } else {
            console.error(response.data)
            reject(response.data.message)
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Delete
   */
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
